export  const fetchedOptions = [
    { value: "", label: "Select a type" },
    { value: "Cafe", label: "Cafe" },
    { value: "Restaurant", label: "Restaurant" },
  ];
